import { Box, Link } from "@mui/material";
import PropTypes from 'prop-types';
import React from 'react';
import { Trans } from 'react-i18next';

// Vaste contactadressen per instituut (afkorting van de institute-scope).
// Staat er op de scope zelf een `properties.supportEmail`, dan wint die.
const SUPPORT_EMAILS = {
	DS: 'decentraleselectie@athenastudies.nl',
};

export const getSupportEmail = (institute) => (
	institute?.properties?.supportEmail || SUPPORT_EMAILS[institute?.abbreviation] || null
);

// Contactregel onder het aanbod. Instituten zonder adres krijgen niets.
const ScopeSupportContact = ({ institute }) => {
	const email = getSupportEmail(institute);
	if(!email) return null;

	return (
		<Box sx={{ mt: 3, textAlign: 'center' }}>
			<Trans
				i18nKey="scope.support_contact"
				defaults="Voor vragen, mail naar <0>{{email}}</0>."
				values={{ email }}
				components={[
					<Link key="mailto" href={`mailto:${email}`} />
				]}
			/>
		</Box>
	);
};

ScopeSupportContact.propTypes = {
	institute: PropTypes.object,
};

export default ScopeSupportContact;
